module.exports = __webpack_public_path__ + "static/media/brandcase2.6737da67.png";